import { useState, useEffect, useCallback } from 'react';

export const useSlideshow = (totalSlides, autoPlayInterval = 7000) => {
  const [current, setCurrent] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % totalSlides);
    }, autoPlayInterval);
    
    return () => clearInterval(interval);
  }, [totalSlides, isAutoPlaying, autoPlayInterval]);

  const navigate = useCallback((action, index) => {
    setIsAutoPlaying(false);
    
    if (action === 'goto' && typeof index === 'number') {
      setCurrent(index);
      return;
    }

    setCurrent(prev => {
      if (action === 'prev') {
        return prev === 0 ? totalSlides - 1 : prev - 1;
      }
      return (prev + 1) % totalSlides;
    });
  }, [totalSlides]);

  const indicators = Array.from({ length: totalSlides }, (_, i) => i === current);

  return {
    current,
    navigate,
    indicators,
    isAutoPlaying,
  };
};